import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Role } from '../../models/role';
import { RoleService } from '../../services/role.service';
import 'rxjs/add/operator/switchMap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { RoleDto } from '../../dto/role.dto';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-role-info',
  templateUrl: './role-info.component.html',
  styleUrls: []
})
export class RoleInfoComponent implements OnInit {

  title_component: string;
  title_panel: string;
  role: Role;
  modalRef: BsModalRef;
  message: string;
  button_save_status: boolean;
  button_delete_status: boolean;
  loading = false;

  public status = [
    { value: true, desc: 'Activo' },
    { value: false, desc: 'Inactivo' }
  ];

  constructor(
    private route: ActivatedRoute,
    private roleService: RoleService,
    private location: Location,
    private toastr: ToastrService,
    private router: Router,
    private modalService: BsModalService,
    private baseService: BaseService
  ) { }


  ngOnInit(): any {

    this.title_component = 'Editar Rol';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Editar rol';

    this.role = {
      id: null,
      name: '',
      description: '',
      creationUser: '',
      creationDate: '',
      status: this.status[0].value
    };
    const id = +this.route.snapshot.paramMap.get('id');

    this.roleService.getInfoDetail(id).subscribe(data => {
      this.button_save_status = true;
      this.button_delete_status = true;
      this.role = data;
    });
  }

  goBack(event): any {
    this.location.back();
  }

  edit(value): any {
    this.loading = true;
    const message = 'Sus datos se han actualizado con exito.';
    const id = value.id;
    const dto = new RoleDto(value.name, value.description);

    this.roleService.updateRole(id, dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.loading = false;
          this.showSuccess(message);
          this.router.navigate(['/dashboard/role']);
        }, 1000);
      }
    });
  }

  delete(event, role, templateConfirm: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(templateConfirm, {class: 'modal-sm'});
  }

  showSuccess(message: string): any {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string): any {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  confirm(): any {
    this.loading = true;
    this.message = 'Confirmed!';
    const id = this.role['id'];
    this.roleService.deleteRole(id);
    this.modalRef.hide();

    const message = 'Se elimino con exito.';
    this.button_delete_status = false;

    setTimeout(() => {
      this.loading = false;
      this.showSuccess(message);
      this.router.navigate(['/dashboard/role']);
    }, 1000);
  }

  decline(): any {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/role/role-info.component.ts